import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import MaskedInput from 'react-text-mask';
import Bunexe_service from './../../Bunexe_service';
import Button from 'react-bootstrap/Button';
import { format, addDays } from 'date-fns';
import { FaForward } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import { toast } from 'react-toastify';

const AnMatSess_perm = ({
  setCurrentform,
  currentform,
  infoPh,
  setInfoPh,
  candidatSelectionne,
  setCandidatSelectionne,
}) => {
  const [anPh, setAnPh] = useState('1819');
  const [matPh, setMatPh] = useState('');
  const [startLoading, setStartLoading] = useState(false);

  const [size, setSize] = useState(25);

  let url_ = Bunexe_service.url;

  const Rechercher = () => {};
  const onDisplayInfopermphClick = async (candidatChoisi) => {
    //alert(JSON.stringify(candidatChoisi));
    setInfoPh([]);
    setCandidatSelectionne({ ...candidatSelectionne, ...candidatChoisi });
  };
  const getinfoPh = async () => {
    setStartLoading(true);
    if (matPh.length == 10) {
      try {
        fetch(url_ + `/recherche/permph/${anPh}/${matPh}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.length == 0)
              toast.error('Pas de données', {
                position: toast.POSITION.TOP_RIGHT,
              });
            else setInfoPh(data);
            // setAlreadyLoaded(true)
            setStartLoading(false);
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    } else {
      alert('Les Champs sont Obligatoires ...');
    }
  };

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center'>
              dernière fiche de participation aux Examens d'Etat
            </h2>
          </div>
          <div className='card-body'>
            <Form>
              <Form.Row className='border border-primary rounded p-3 mb-4'>
                <Form.Group as={Col} controlId='formAnph'>
                  <Form.Label>Annee PH</Form.Label>
                  <Form.Control
                    as='select'
                    value={anPh}
                    onFocus={(e) => {
                      setInfoPh([]);
                    }}
                    onChange={(e) => {
                      setAnPh(e.target.value);
                    }}
                  >
                    {Bunexe_service.Annee_academique.map((s, index) => (
                      <option key={index} value={s.an}>
                        {s.libelle}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col} controlId='formMatph'>
                  <Form.Label>No. Ordre PH</Form.Label>
                  <MaskedInput
                    mask={[
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                    ]}
                    className='form-control'
                    placeholder='Matricule Philo'
                    value={matPh}
                    name='matPh'
                    onFocus={(e) => {
                      setInfoPh([]);
                      setCandidatSelectionne({});
                    }}
                    onChange={(e) => {
                      setMatPh(e.target.value);
                    }}
                    guide={true}
                  />
                </Form.Group>
                <Button
                  className='btn-block'
                  style={{ marginTop: '20px', marginBottom: '10px' }}
                  variant='primary'
                  onClick={getinfoPh}
                >
                  Rechercher
                </Button>
              </Form.Row>
              <div className='container'>
                {startLoading && (
                  <div
                    style={{ width: '100%' }}
                    className='d-flex justify-content-center'
                  >
                    <Spinner animation='border' variant='info' />
                  </div>
                )}
                <ReactTooltip />
                {infoPh.length > 0 && (
                  <ul className='list-group list-group-flush'>
                    {infoPh.map((d) => (
                      <li
                        key={d.CLEUNIQUE}
                        className='list-group-item d-flex justify-content-between'
                      >
                        <>
                          {d.NOMEL} {d.PRENOMEL} {', Né(e) à '} {d.LOCNAISS}{' '}
                          {' le '}
                          {format(
                            addDays(
                              new Date(
                                d.DNAISS.substr(0, 4)
                                  .concat('-')
                                  .concat(d.DNAISS.substr(4, 2))
                                  .concat('-')
                                  .concat(d.DNAISS.substr(6, 2))
                              ),
                              1
                            ),
                            'dd/MM/yyyy'
                          )}
                          {', Philo :' + d.IDSECTION.substr(1, 1)}
                          {', Session :( ' + d.SESSION + ' )'}
                        </>
                        <FaForward
                          data-tip='Ajouter ...'
                          className='ml-4'
                          size={size}
                          onMouseOver={(e) => setSize(30)}
                          onMouseOut={(e) => setSize(25)}
                          onClick={(e) => {
                            onDisplayInfopermphClick(d);
                            setCurrentform(currentform + 1);
                          }}
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Form>
          </div>

          <div className='card-footer'>
            {/*            
            <div className='d-flex justify-content-between mt-3'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                Siège
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => {
                  candidatSelectionne &&
                  candidatSelectionne.NOMEL &&
                  candidatSelectionne.NOMEL.length > 0
                    ? setCurrentform(currentform + 1)
                    : alert(
                        `Il Faut selectionner l'annee academique et le matricule du candidat`
                      );
                }}
              >
                Email
              </button>
            </div>
          */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnMatSess_perm;
